// extracted by mini-css-extract-plugin
export default {"actionBar":"dL8_gSbsZUu7terSp6XT","digitalClockSectionItem":"iXKp5FdSDjxxrH4tb3n_"};